import React, {useEffect, useState} from "react";
import '@simonwep/pickr/dist/themes/nano.min.css';
import Pickr from '@simonwep/pickr';
import styles from "./processCompareSidebarColorPicker/ProcessCompareSidebarColorPicker.module.scss";
import Button from "../../../../Componnets/Button/Button";

const ProcessCompareSidebarColorPicker = ({ info = {color: "ffffff"}, handleChangeColor, handleCloseStep }) => {

    const [color, setColor] = useState(info.color);

    const handleSubmit = () => {
        handleChangeColor({color, layer: info.layer, id: info.id});
        handleCloseStep();
    }

    useEffect(() => {
        const pickr = Pickr.create({
            el: '.color-picker',
            theme: 'nano',
            default: color,
            swatches: [
                '#FF0053',
                '#FFC700',
                '#0A195C',
                '#70789E',
                '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'),
                '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'),
                '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0')
            ],
            inline: true,
            showAlways: true,
            appClass: 'color-picker',
            components: {
                palette: true,
                preview: false,
                interaction: {
                    input: true,
                }
            },
        })

        pickr.on('changestop', (source, instance) => {
            setColor(instance._color.toHEXA().toString());
        }).on('swatchselect', (color, instance) => {
            setColor(color.toHEXA().toString());
        });
    }, []);

    return (
        <div className={styles.ProcessCompareSidebarColorPicker}>
            <div className="color-picker"></div>
            <div>
                <Button
                    onClick={handleSubmit}
                    title={'Save'}
                    type={'primary'}
                    size={'block'}
                    height={'medium'}
                />
            </div>
        </div>
    )
}

export default ProcessCompareSidebarColorPicker;